var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"data-test":"dashboard"}},[(_vm.isPatient)?_c('home-patient'):_c('home-professional')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }